// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-issue-seller-briefly-personal-ledger-component',
//   standalone: true,
//   imports: [],
//   templateUrl: './issue-seller-briefly-personal-ledger-component.component.html',
//   styleUrl: './issue-seller-briefly-personal-ledger-component.component.scss'
// })
// export class IssueSellerBrieflyPersonalLedgerComponentComponent {

// }
import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-issue-seller-briefly-personal-ledger-component',
  standalone: false,
  templateUrl: './issue-seller-briefly-personal-ledger-component.component.html',
  styleUrls: ['./issue-seller-briefly-personal-ledger-component.component.scss'],
})
export class IssueSellerBrieflyPersonalLedgerComponentComponent implements OnInit {

  getpersonalledBridflydata: any;
  balancecfamt: any;
  reportType: string = '';
  startDate: any = '';
  endDate: string = '';
  offRepName: string = '';
  repname: string = '';
  issueDates: string = '';
  Totalop: number;
  Totalnet: number;
  TotalCreditTotal: number;
  Totalrcv: number;
  TotalCredit: number;
  totalbalance: number;
  Totalbal: number;
  currentDate: string;
  totaldepo: number;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerBrieflyPersonalLedgerComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.reportType = this.data?.reportType || '';
    this.filters(); // ✅ call the method
  }

  filters(): void {
    let repname: any = this.data['repName'];

    if (repname != "") {
      repname = [repname];
    }

    const req: any = {
      "rep_name": repname,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_seller_name": this.data['name'],
      "issue_date": this.issueDates
    };

    const req1: any = {
      "startDate": this.data['startDate'],
      "endDate": this.data['endDate'],
      "issue_seller_name": this.data['name']
    };
    this.startDate=this.data['startDate']
    this.endDate=this.data['endDate']
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; 
    
    this.service.getIssuePersoanlLedBriefly(req1).subscribe((data: any) => {
      console.log("Get ledgerdata briefly", data);
      this.getpersonalledBridflydata = data as any;

      // Initialize totals
      this.Totalop = 0;
      this.Totalnet = 0;
      this.Totalrcv = 0;
      this.TotalCreditTotal = 0;
      this.TotalCredit = 0;
      this.Totalbal = 0;
      this.totalbalance = 0;
      this.totaldepo=0;

      // Loop through the data and calculate totals
      for (let data of this.getpersonalledBridflydata) {
        const openingBal = parseFloat(data.opening_bal) || 0;
        const netAmt = parseFloat(data.net_amt) || 0;
        const rcvAmt = parseFloat(data.rcv_amt) || 0;
        const creditAmt = parseFloat(data.credit_amt) || 0;
        const totalReceivedAmt = parseFloat(data.total_received_amt) || 0;
        const balAmt = parseFloat(data.bal_amt) || 0;
        const depo=parseFloat(data.deposit||0);

        this.Totalop += openingBal;
        this.Totalnet += netAmt;
        this.Totalrcv += rcvAmt;
        this.TotalCredit += creditAmt;
        this.TotalCreditTotal += totalReceivedAmt;
        this.Totalbal += balAmt;
        this.totaldepo += depo;

        // Debugging logs
        // console.log(`Opening Bal: ${openingBal}, Net Amt: ${netAmt}, Rcv Amt: ${rcvAmt}, Credit Amt: ${creditAmt}, Total Received Amt: ${totalReceivedAmt}, Bal Amt: ${balAmt}`);
      }

      // Debugging logs for totals
      console.log(`Total Opening Bal: ${this.Totalop}`);
      console.log(`Total Net Amt: ${this.Totalnet}`);
      console.log(`Total Rcv Amt: ${this.Totalrcv}`);
      console.log(`Total Credit Amt: ${this.TotalCredit}`);
      console.log(`Total Credit Total: ${this.TotalCreditTotal}`);
      console.log(`Total Bal Amt: ${this.Totalbal}`);
      console.log(`reportype: ${this.reportType}`);
    });
  }
exportExcel(fileName: string): void {
  // Map data to match exact HTML column order and headers
  const exportData = this.getpersonalledBridflydata.map((data1: any) => ({
    'Issue Seller Name': data1.issue_seller_name,
    'Deposit': data1.deposit || 0,
    'Opening Balance': parseFloat(data1.opening_bal || 0).toFixed(2),
    'Billing Amount': parseFloat(data1.net_amt || 0).toFixed(2),
    'Received Amount': parseFloat(data1.rcv_amt || 0).toFixed(2),
    'Credit Note Amount': parseFloat(data1.credit_amt || 0).toFixed(2),
    'Total Amount': parseFloat(data1.total_received_amt || 0).toFixed(2),
    'Balance': parseFloat(data1.bal_amt || 0).toFixed(2),
  }));

  // Append totals row to match HTML footer
  exportData.push({
    'Issue Seller Name': 'Total',
    'Deposit': this.totaldepo.toFixed(2),
    'Opening Balance': this.Totalop.toFixed(2),
    'Billing Amount': this.Totalnet.toFixed(2),
    'Received Amount': this.Totalrcv.toFixed(2),
    'Credit Note Amount': this.TotalCredit.toFixed(2),
    'Total Amount': this.TotalCreditTotal.toFixed(2),
    'Balance': this.Totalbal.toFixed(2),
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

  // Style header row - bold + light blue background matching HTML
  const headerRange = XLSX.utils.decode_range(worksheet['!ref']!);
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'D0E4FF' } },
      alignment: { horizontal: 'center' }
    };
  }

  // Style totals row - bold + light blue background matching HTML footer
  const totalRowIndex = exportData.length; // last row (1-based + header = exportData.length)
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: col });
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'D0E4FF' } },
      alignment: { horizontal: col === 0 ? 'left' : 'right' }
    };
  }

  // Auto column widths
  worksheet['!cols'] = [
    { wch: 30 }, // Issue Seller Name
    { wch: 14 }, // Deposit
    { wch: 18 }, // Opening Balance
    { wch: 18 }, // Billing Amount
    { wch: 18 }, // Received Amount
    { wch: 20 }, // Credit Note Amount
    { wch: 16 }, // Total Amount
    { wch: 14 }, // Balance
  ];

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Issue Seller Ledger': worksheet },
    SheetNames: ['Issue Seller Ledger']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
    cellStyles: true  // ← Required for styles to apply
  });

  this.saveAsExcelFile(excelBuffer, fileName);
}
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + '.xlsx');
  }



}